const DETAILS_FORM_AGREEMENTS_MARKETING_GET = 'DETAILS_FORM_AGREEMENTS_MARKETING_GET';
const DETAILS_FORM_AGREEMENTS_MARKETING_FETCH_ERROR = 'DETAILS_FORM_AGREEMENTS_MARKETING_FETCH_ERROR';
const DETAILS_FORM_AGREEMENTS_MARKETING_SET = 'DETAILS_FORM_AGREEMENTS_MARKETING_SET';
const DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE = 'DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE';



const accountFormAgreementsMarketingGet = () => ({
  type: DETAILS_FORM_AGREEMENTS_MARKETING_GET
});

const accountFormAgreementsMarketingSet = (agreements) => ({
  type: DETAILS_FORM_AGREEMENTS_MARKETING_SET,
  payload: {
    agreements
  }
});

const accountFormAgreementsMarketingToggle = (agreement) => ({
  type: DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE,
  payload: {
    agreement
  }
});

const accountFormAgreementsFetchError = () => ({
  type: DETAILS_FORM_AGREEMENTS_MARKETING_FETCH_ERROR
});

export {
  DETAILS_FORM_AGREEMENTS_MARKETING_SET,
  DETAILS_FORM_AGREEMENTS_MARKETING_GET,
  DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE,
  accountFormAgreementsFetchError,
  accountFormAgreementsMarketingToggle,
  accountFormAgreementsMarketingGet,
  accountFormAgreementsMarketingSet
};
